import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import HeaderContent from "../../headerContent/HeaderContent";
import BadgeScanOption from "./BadgeScan";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { FormattedMessage } from "react-intl";
import ManualLoginOption from "./ManualLogin";
import { publishCountToCSM } from "../../../overview/utils/utils";
import { DolphinVerificationProcessName } from "../../../util/Constants";

function VerificationOptions({
  alias,
  setAlias,
  showQRCode,
  onGenerateQRCode,
  setShowQRCode,
  tokenValue,
  setAliasError,
  aliasError,
}) {
  const [currentTab, setCurrentTab] = useState("manual-input");
  const onBadgeScanClick = () => {
    setCurrentTab("badge-scan");
    publishCountToCSM({
      processName: DolphinVerificationProcessName,
      metricName: "Badge-scan",
    });
  };

  return (
    <Column>
      <HeaderContent />
      <Row>
        <TabGroup
          value={currentTab}
          onChange={setCurrentTab}
          type="default"
          fill="line"
        >
          <Tab value="manual-input" id="manual-input">
            <FormattedMessage
              id="verificationOptions.text.loginOption"
              defaultMessage="Login ID"
            />
          </Tab>
          <Tab value="badge-scan" id="badge-scan" onChange={onBadgeScanClick}>
            <FormattedMessage
              id="verificationOptions.text.badgeOption"
              defaultMessage="Badge"
            />
          </Tab>
        </TabGroup>
      </Row>
      {currentTab === "badge-scan" && (
        <Row>
          <BadgeScanOption
            setShowQRCode={setShowQRCode}
            setAlias={setAlias}
            onGenerateQRCode={onGenerateQRCode}
            tokenValue={tokenValue}
            setAliasError={setAliasError}
            aliasError={aliasError}
          />
        </Row>
      )}
      {currentTab === "manual-input" && (
        <Row>
          <ManualLoginOption
            alias={alias}
            setAlias={setAlias}
            showQRCode={showQRCode}
            onGenerateQRCode={onGenerateQRCode}
            tokenValue={tokenValue}
            setAliasError={setAliasError}
            aliasError={aliasError}
          />
        </Row>
      )}
    </Column>
  );
}

export default VerificationOptions;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/verificationWindow/verificationOptions/VerificationOptions.js